"use client";

import React from "react";

//Type
import { ModalVideoProps } from "@/types";

//Styled
import * as S from "./styles";

//Components
import { DialogDescription } from "@/components/ui/dialog";

//Icon
import { Youtube } from "lucide-react";

const ModalVideo: React.FC<ModalVideoProps> = ({
  TumbVideo,
  TitleVideo,
  LinkVideo,
}) => {
  return (
    <S.Modal>
      <S.ButtonModal>
        <S.BoxImageVideo>
          <Youtube />
          <S.TumbVideo src={TumbVideo} />
        </S.BoxImageVideo>
        <S.TitleVideo>{TitleVideo}</S.TitleVideo>
      </S.ButtonModal>
      <S.ModalContent>
        <S.ModalHeader>
          <S.TitleModalVideo>{TitleVideo}</S.TitleModalVideo>
          <DialogDescription>
            <S.IframeComponent
              height="315"
              src={LinkVideo}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            ></S.IframeComponent>
          </DialogDescription>
        </S.ModalHeader>
      </S.ModalContent>
    </S.Modal>
  );
};

export default ModalVideo;
